<template>
  <FiltersDesktop
    v-model:filtersValues="filtersValues"
    class="mb-32 hidden md:block"
    :resetFilters
    :shouldShowBackshipFilter
    :shouldShowMissingActionFilter
    :shouldShowOrderStateFilter
    :submitFilters
  />
  <FiltersMobile
    v-model:filtersValues="filtersValues"
    class="md:hidden"
    :resetFilters
    :shouldShowBackshipFilter
    :shouldShowMissingActionFilter
    :shouldShowOrderStateFilter
    :submitFilters
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import type { Preset } from '../../Tab.types'

import type { FilterValues } from './Filters.types'
import FiltersDesktop from './components/FiltersDesktop/FiltersDesktop.vue'
import FiltersMobile from './components/FiltersMobile/FiltersMobile.vue'

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

const props = defineProps<{
  resetFilters: () => void
  submitFilters: () => void
  preset: Preset
}>()

const { isFeatureEnabled } = useBusinessFeaturesStore()

const shouldShowBackshipFilter = isFeatureEnabled('backshipEnabled')

const shouldShowMissingActionFilter = computed(
  () => props.preset === 'needing-response',
)
const shouldShowOrderStateFilter = computed(
  () => props.preset === 'needing-response' || props.preset === 'all',
)
</script>
